import Layout, { LayoutProps } from './Layout';

export default Layout;
export type {
  LayoutProps,
};
